// extracted by mini-css-extract-plugin
module.exports = {"info__header":"Info_info__header__3B4M-","info__card":"Info_info__card__1-GPb"};